window.images =
{
    load: async function (callback)
    {
        const imageElements = document.querySelectorAll(".async-load");

        if (!imageElements)
            return;

        var tasks = [];

        imageElements.forEach(imageElement =>
        {
            var promise = new Promise(async (resolve, reject) =>
            {
                var url = `${document.baseURI}api/images/image?path=${encodeURIComponent(imageElement.getAttribute("data-src"))}`;

                if (imageElement.dataset.format)
                    url += "&format=" + imageElement.dataset.format;

                if (imageElement.dataset.defaultFormat)
                    url += "&defaultFormat=" + imageElement.dataset.defaultFormat;

                if (imageElement.dataset.width)
                    url += "&width=" + imageElement.dataset.width;

                if (imageElement.dataset.height)
                    url += "&height=" + imageElement.dataset.height;

                if (imageElement.dataset.aspectRatio)
                    url += "&aspectRatio=" + imageElement.dataset.aspectRatio;

                if (imageElement.dataset.squared)
                    url += "&squared=" + imageElement.dataset.squared;

                if (imageElement.dataset.quality)
                    url += "&quality=" + imageElement.dataset.quality;

                var data = null;

                try
                {
                    var response = await fetch(url,
                    {
                        method: "GET"
                    });

                    if (!response.ok)
                    {
                        var error = await response.text();

                        console.error('Error:', error);

                        reject(error);

                        return;
                    };

                    data = await response.json();
                }
                catch (error)
                {
                    console.error('Error:', error);

                    reject(error);

                    return;
                }

                if (data.length == 0)
                    reject("File not found.");

                var picture = document.createElement("picture");

                if (imageElement.dataset.pictureClass)
                    picture.className = imageElement.dataset.pictureClass;

                var avif = data
                    .filter(x => x.format === 0)
                    .map(x => x.filePath)
                [0];

                if (avif)
                {
                    var avifSource = document.createElement("source");
                    avifSource.srcset = avif;
                    avifSource.type = "image/avif";

                    picture.appendChild(avifSource);
                }

                var webp = data
                    .filter(x => x.format === 3)
                    .map(x => x.filePath)
                [0];

                if (webp)
                {
                    var webpSource = document.createElement("source");
                    webpSource.srcset = webp;
                    webpSource.type = "image/webp";

                    picture.appendChild(webpSource);
                }

                var src = data
                    .filter(x => x.format !== 0 && x.format !== 3)
                    .map(x => x.filePath)
                [0];

                var img = document.createElement("img");
                img.src = src;
                img.loading = imageElement.dataset.loadingType && imageElement.dataset.loadingType.toLowerCase() == "eager" ? "eager" : "lazy";
                img.decoding = "async";
                img.alt = imageElement.dataset.alt;
                img.className = imageElement.dataset.class;

                if (imageElement.dataset.style)
                    img.setAttribute("style", imageElement.dataset.style);

                if (imageElement.dataset.id)
                    img.setAttribute("id", imageElement.dataset.id);

                if (imageElement.dataset.width)
                    img.setAttribute("width", imageElement.dataset.width);

                if (imageElement.dataset.zoom)
                    img.setAttribute("data-zoom", src);

                for (var i = 0; i < imageElement.attributes.length; i++)
                {
                    if (!imageElement.attributes[i].nodeName.startsWith("data-dynamic"))
                        continue;

                    var keyName = imageElement.attributes[i].nodeName.substring("data-dynamic-".length);

                    img.setAttribute("data-" + keyName, imageElement.attributes[i].nodeValue);
                }

                picture.appendChild(img);

                if (imageElement.parentNode)
                    imageElement.outerHTML = picture.outerHTML;

                resolve();
            });

            tasks.push(promise);
        })

        await Promise.all(tasks);

        if (callback)
            callback();
    }
};